module.exports = __webpack_public_path__ + "img/kleisma4m-m@2.72ec67d9.webp";